export const downloadFile = (url, fileName) => {
  if (!url) {
    return;
  }

  // 定义文件名
  if (!fileName) {
    const num = url.lastIndexOf('/') + 1;
    fileName = url.substring(num);
    fileName = decodeURI(fileName.split('?')[0]);
  }

  // 保存文件
  const saveLink = document.createElement('a');
  document.body.appendChild(saveLink);
  saveLink.style.display = 'none';
  saveLink.href = url;
  saveLink.download = fileName;
  saveLink.click();
  document.body.removeChild(saveLink);
};
